export default __webpack_public_path__ + "static/media/6.aa4acd48.png";